<template>
  <div>
    <AddGoal :showAddGoal="showAddGoal" @close="showAddGoal = false"></AddGoal>
    <div class="bg-white m-3 rounded-md">
<!--      <div class="flex items-center w-full">
        <progress-circle
          class=""
          :completed-steps="80"
          :total-steps="100"
          start-color="green"
          stop-color="#DEA42C"
          circle-color="#E6E4E4"
        >
          <p class="text-xl font-bold">{{ (80 / 100) * 100 }}%</p>
          <small class="text-xs">Complete</small>
        </progress-circle>
        <div class="flex flex-col">
          <h1 class="font-bold text">23 Days Left</h1>
          <small class="text-xs">To closure of review</small>
        </div>
        <div class="flex"></div>
      </div>-->
      <div
        class="border-b-0.5 lg:gap-0 gap-5 items-center p-3 w-full"
      >
        <employee-list />
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeList  from "./employeeList"
export default {
  name: "ObjectivesHome",
  components: {
   EmployeeList
  },
  data() {
    return {
      activeTab: "Goals",
      showAddGoal: false,
      currentScore: 3,
      tabs: [
        { name: "Goal Setting", component: "Goals" },
        { name: "My Review", component: "MyReview" },
        { name: "Manager Review", component: "ManagerReview" },
        { name: "Joint Review", component: "JointReview" },
        { name: "Recommendation", component: "Recommendation" },
        { name: "Report", component: "Report" },
      ],
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  methods: {
    errorHandler() {
      return true;
    },
  },
};
</script>
